<template>
    <div id="app">
        <PvCarousel/>
    </div>
</template>

<script>
    import PvCarousel from './components/PvCarousel.vue';
    import PvApiService from './services/PvApiService';
    import 'bootstrap/dist/css/bootstrap.css';
    import 'bootstrap-vue/dist/bootstrap-vue.css';
    import store from './services/VuexStore';

    export default {
        name: 'app',
        components: {
            PvCarousel,
        },
        methods: {
            refreshPvData () {
                this.pvApiService.getGranularToday().then((response) => {
                    store.commit('setGranular', response);
                });

                this.pvApiService.getGeneralToday().then((response) => {
                    store.commit('setGeneral', response);
                });
            },
        },
        mounted () {
            this.pvApiService = new PvApiService();
            this.refreshPvData();
            setInterval(this.refreshPvData, 60 * 1000);
        },
    };
</script>

<style>
    @font-face
    {
        font-family: chalk;
        src: url('https://cdn.gemeindeplaner.at/pv-wimsbach/DK+Crayon+Crumble.ttf');
    }

    #app {
        font-family: 'chalk', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: white;
        height: 100vh;
        font-size: 22px;
        width: 100vw;
        background: url('https://cdn.gemeindeplaner.at/pv-wimsbach/chalkboard.jpg') no-repeat;
        background-size: cover;
    }

    body {
        margin: 0;
    }
</style>
